const authDictionary = {
  sendOtp: () => `api/v1/user/send-otp`,
  sendRegisterOtp: () => `api/v1/onboarding/signup-otp`,
  reSendRegisterOtp: () => `api/v1/onboarding/resend-signup-otp`,
  /** Register user: send OTP (key = email or mobile) */
  authSendOtp: () => `api/v1/auth/send-otp`,
  /** Register user: verify OTP (key = email or mobile) */
  authVerifyOtp: () => `api/v1/auth/verify-otp`,
  verifyOtp: () => `api/v1/user/otp-verify`,
  verifyRegisterOtp: () => `api/v1/onboarding/signup-otp/verify`,
  signupOnboard: () => `api/v1/onboarding/signup-onboard`,
  setPassword: () => `api/v1/user/set-password`,
  customerLogin: () => `api/v2/user/customer-login`,
  getLogin: () => `api/v1/user/get-auth`,
  setLogin: () => `api/v2/user/loan-type-permission`,
  uploadImage: () => `api/v1/user/upload-image`,
  registerNewUser: () => `api/v1/auth/register`,
  sendCoApplicantOtp: () => `api/v1/co-applicant/send-coapplicant-otp`,
  verifyCoApplicantOtp: () => `api/v1/co-applicant/coapplicant-otp-verify`,
  bypassLogin: () => `api/v1/user-lead/bypass-login`,
  logout: () => `api/v1/user/logout`,
};

export default authDictionary;
